import { Component, Prop, Vue} from "vue-property-decorator";
import { StraightWallSectionModuleModel, StraightWallModel, StraightWallSection, ConfiguratorValueUpdateModel, ValueDescription, WallTypes } from "../models";
import { productConfiguratorStore as store} from "./../store";
import { ValidationProvider, extend } from "vee-validate";
import {  between, min_value } from "vee-validate/dist/rules";
import HtmlElementHelper from "@/services/HtmlElementHelper";
import Cookie from "@/services/Cookie";

extend("between", {
    ...between,
    // message: store.translations.notWithinValidIntervalMessage
  });

extend("min_value", {
    ...min_value,
    message: store.translations.belowAllowedLimitMessage
});

@Component(
    {
        components: {
            ValidationProvider
          }
    }
)
export default class StraightWallSectionModule extends Vue {

    @Prop()
    protected vm!: StraightWallSectionModuleModel;
    protected selectedCustomConfiguratorProductCookie: string = "";

    protected straightWallModel: StraightWallModel = { wallSections: []} as StraightWallModel;

    protected created() {
        if (!this.straightWallModel.wallSections.length) {
            this.addSection();
        }
        this.getCookie();
    }

    protected getCookie() {
        this.selectedCustomConfiguratorProductCookie = Cookie.getCookie("SelectedCustomConfiguratorProducts-" + this.vm.configuratorType);
        Cookie.applyCustomCookies(this.vm, this.selectedCustomConfiguratorProductCookie, this.straightWallModel);
        if (this.selectedCustomConfiguratorProductCookie !== "") {
            this.tryUpdateConfiguratorValue();
        }
    }

    protected addSection() {
        const tempSections = this.straightWallModel.wallSections;
        tempSections.push({} as StraightWallSection);
        this.straightWallModel.wallSections = tempSections;
    }

    protected deleteSection(sectionIndex: number) {
        const tempSections = this.straightWallModel.wallSections;
        tempSections.splice(sectionIndex, 1);
        this.straightWallModel.wallSections = tempSections;
        if (!this.straightWallModel.wallSections.length) {
            this.addSection();
        }
        this.tryUpdateConfiguratorValue();
    }

    protected tryUpdateConfiguratorValue() {
        if (this.isRetainingWall) {
           if (this.straightWallModel.wallSections.every(s => s.heightRetainingWall > 0 && s.heightRetainingWall <= this.retainingWallMaxHeight && s.length > 0)) {
                this.updateConfiguratorValue();
            }
        } else if (this.straightWallModel.wallSections.every(s => s.heightAboveGround > 0 && s.heightAboveGround <= this.dividingWallMaxHeight && s.length > 0)) {
            this.straightWallModel.wallSections.forEach(s => s.heightRetainingWall = 0);
            this.updateConfiguratorValue();
        }
    }

    protected handleInputDebounce(inputValue: any, event: Event) {
        if (HtmlElementHelper.isEventTargetFocusedElement(event.target)) {
            this.tryUpdateConfiguratorValue();
        }
    }

    private updateConfiguratorValue() {
        let valueDescriptions: ValueDescription[];
        if (this.isRetainingWall) {
            valueDescriptions = this.straightWallModel.wallSections
            .map(section => ({
                title: section.name ? section.name : store.translations.unnamedWallSection,
                text: `${ store.translations.commonLength}: ${ section.length} m, ${ store.translations.heightRetainingWall}: ${section.heightRetainingWall} m, ${ store.translations.heightAboveGround}: ${section.heightAboveGround ? section.heightAboveGround : 0 } m`
                }));
        } else {
            valueDescriptions = this.straightWallModel.wallSections
            .map(section => ({
                title: section.name ? section.name : store.translations.unnamedWallSection,
                text: `${ store.translations.commonLength}: ${ section.length} m, ${ store.translations.commonHeight}: ${section.heightAboveGround} m`
                }));
        }

        const updateModel: ConfiguratorValueUpdateModel = { moduleId: this.vm.id, value: this.straightWallModel, valueDescriptions,
            propertyName: this.vm.configuratorProperties[0].propertyName, isText: false, resetClimateSavingsCookie: false };
        this.$emit("update-configurator-value", updateModel, true);
    }

    get translations() {
        return store.translations;
    }

    get dividingWallMaxHeight() {
        return 2.4;
    }

    get retainingWallMaxHeight() {
        return 1.1;
    }

    get heightAboveGroundMinHeight() {
        return this.isRetainingWall ? 0 : 0.1;
    }

    get isRetainingWall() {
        return store.configuratorValues.some(cv => cv.property.propertyName === "WallType" && cv.value ===  WallTypes.Retaining.toString());
    }
}
